export const isDefined = (value: any): boolean => { // eslint-disable-line @typescript-eslint/no-explicit-any
  if (value === null) return false;
  if (value === undefined) return false;
  if (value === "") return false;
  if (isNaN(value)) return !!value;
  if (typeof value === "object") return !!Object.keys(value).length;

  return true;
};
